module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage3-desktop.jpg?v=4910ba10";